import React from 'react';

import SolarPowerIcon from '@mui/icons-material/SolarPower';
import { useTheme } from '@mui/material/styles';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { PV_LAYOUT_TYPE } from 'common/constants';

import { getIsFetchingPvLayout, getPvLayoutData } from '../selectors';

import SideMenuCard from './SideMenuCard';

const PvLayoutCard = ({
    handleClickDocumentItem,
    isDisabled,
    selectedDocument,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const title = t('PV layout');

    const isFetchingPvLayout = useSelector(getIsFetchingPvLayout);
    const pvLayoutData = useSelector(getPvLayoutData);

    const selectedDocumentId = selectedDocument ? selectedDocument.id : null;

    const parentFieldSegment = get(
        pvLayoutData,
        `parent_field_segments[0]`,
        {},
    );

    if (
        isFetchingPvLayout ||
        pvLayoutData === null ||
        isEmpty(parentFieldSegment)
    )
        return null;

    const pvLayoutId = parentFieldSegment.id;

    return (
        <SideMenuCard
            icon={<SolarPowerIcon sx={{ color: 'primary.main' }} />}
            title={title}
        >
            <List disablePadding>
                <ListItem disabled={isDisabled} disablePadding>
                    <ListItemButton
                        onClick={() =>
                            handleClickDocumentItem({
                                id: pvLayoutId,
                                name: 'PV layout',
                                type: PV_LAYOUT_TYPE,
                            })
                        }
                        selected={pvLayoutId === selectedDocumentId}
                        sx={{
                            borderRadius: '8px',
                            backgroundColor:
                                pvLayoutId === selectedDocumentId
                                    ? isDarkMode
                                        ? '#000'
                                        : 'rgba(31, 60, 83, 0.13)'
                                    : 'transparent',
                            '&.Mui-selected': {
                                backgroundColor: isDarkMode
                                    ? '#000'
                                    : 'rgba(31, 60, 83, 0.13) !important',
                            },
                        }}
                    >
                        <ListItemText
                            primary={t('View PV layout')}
                            sx={{
                                '.MuiListItemText-primary': {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            </List>
        </SideMenuCard>
    );
};

PvLayoutCard.propTypes = {
    handleClickDocumentItem: PropTypes.func,
    isDisabled: PropTypes.bool,
    selectedDocument: PropTypes.object,
};

export default PvLayoutCard;
